<template>
    <div class="ListContent">
            <div class="ul-box">
               <div class="li-box clearfix" v-for="(item, index) of listData" :key="index" @click="goDetail(item.id,item.class)">
                   <div class="img-left fl">
                        <img :src="item.img" alt="" class="img-responsive">
                    </div>
                    <div class="img-right fr">
                        <p class="title txt_limit2">{{item.title}}</p>
                        <div class="describe">
                            <span class="fl fs12 color-gray time">{{item.addtime}}</span>
                            <div class="fr class_name" :style="{color:tagColor, border:'1px solid '+tagColor+''}">{{item.class}}</div>
                        </div>
                    </div>
               </div>  
           </div>
    </div>
</template>

<script>
export default {
    props: {
        listData:{
            type:Array,
            default:()=>{}
        }, 
    },
    data() {
        return {
            tagColor:'#FF943D'
        };
    },
    computed: {

    },
    created() {
       
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        goDetail(id,name){
            this.$emit("update", id,name)
        },
    },
    components: {
        
    },      
};
</script>

<style scoped lang="less">
.ul-box{
    width:100%;
    padding:16px;
    .li-box{
        height:80px;
        padding:8px;
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1);
        border-radius:6px;
        margin-bottom:8px;
        .img-left{
            width:80px;
            height:60px;
        }
        .img-right{
            width:239px;
            height:60px;
            font-size:15px;
            color:#333;
            .title{
                height:42px;
                margin-bottom:2px;
            }
            .time{
                height:17px;
                line-height:17px;
            }
            .class_name:empty{padding:0;border:none;}
            
        }

    }
}
</style>



// WEBPACK FOOTER //
// src/components/ListContent.vue